import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/jushuitan_inventory_out_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  io_id_eq: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
    column_name: 'ioId',
  },
  so_id_eq: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
    column_name: 'soId',
  },
  o_id_eq: {
    column_type: 'belongs_to',
    column_name: 'order',
    extra: {
      model_name: 'JushuitanOrder',
      value_column: 'o_id',
    },
    model_name: 'JushuitanInventoryOut',
  },
  order: {
    column_type: 'belongs_to',
    column_name: 'order',
    extra: {
      model_name: 'JushuitanOrder',
      value_column: 'o_id',
    },
    model_name: 'JushuitanInventoryOut',
  },
  status_eq: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
    column_name: 'status',
  },
  status_in: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
    column_name: 'status',
  },
  customer_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  customer: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  customer_user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  customer_customer_source_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_source',
    extra: {
      model_name: 'CustomerSource',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_source: {
    column_type: 'belongs_to',
    column_name: 'customer_source',
    extra: {
      model_name: 'CustomerSource',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_customer_level_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_level: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_customer_tags_id_eq: {
    model_name: 'CustomerTag',
    column_type: 'string',
    column_name: 'id',
  },
  customer_customer_business_models_id_eq: {
    model_name: 'CustomerBusinessModel',
    column_type: 'string',
    column_name: 'id',
  },
}
export const formColumnsConfig = {
  'self': {
    'o_id': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('JushuitanInventoryOut', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('JushuitanInventoryOut', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
